var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5"},[_c('DataLabel',[_vm._v("Status")]),_c('p',{staticClass:"text-xl font-extrabold tracking-tight",class:( _obj = {
      'text-gray-900': !_vm.statusMessage.color
    }, _obj[_vm.statusMessage.color] = _vm.statusMessage.color, _obj )},[_vm._v(" "+_vm._s(_vm.statusMessage.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }